import React, {forwardRef} from 'react';
import TextInput from './TextInput';

const PasswordInput = forwardRef((props, ref) => {
  return <TextInput {...props} ref={ref} type="password" secureTextEntry />;
});

export default PasswordInput;
